import { Component, Input, OnInit } from '@angular/core';
import { NumericDataBarItem } from './models/numeric-data-bar-item.model';
import NumericDataBarView from './numeric-data-bar.component.html';

@Component({
  selector: 'numeric-data-bar',
  template: NumericDataBarView,
  styles: [
    `.numeric-data-bar {
      background-color: #f3f6fb; 
      width: 100%;
      display: flex;
      flex-direction: row !important;
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 10px;
    }`,`
      .numeric-data-number {
        font-size: 24px;
        font-weight: 400;
      }
    `,
    `.numeric-data { text-align: center; margin: 4px; flex-grow: 1; cursor: pointer; }`,
    `.numeric-data-label { word-wrap:break-word;}`,
    `.bg-warning-custom {
        background-color: #c4a84d;
    }`,
    `.bg-default-custom {
      background-color: #c2c2c2;
    }`
  ]
})
export class NumericDataBarComponent implements OnInit {
  @Input() data: NumericDataBarItem[];

  constructor() { }

  ngOnInit() {
  }

}
